import React from 'react';

const FACTS = [
  'Prompt → first factory draft in 30 minutes',
  '8-check kinematic oracle on every program',
  '600+ collision samples per program',
  'Deterministic CP-SAT shift planning',
  'Native code runs unmodified on the controller',
  '27% faster cycles after optimization',
  'Exports: STEP · DXF · XLSX · AutomationML',
];

const ProofStrip = () => (
  <section className="border-y border-black/10 dark:border-white/10 bg-white dark:bg-black">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap justify-center gap-x-10 gap-y-3">
      {FACTS.map((f) => (
        <div key={f} className="flex items-center gap-3 font-mono text-[11px] sm:text-xs tracking-[0.14em] uppercase text-gray-500 dark:text-gray-400">
          <span className="w-1 h-1 rounded-full bg-emerald-500 dark:bg-emerald-400 flex-shrink-0"></span>
          {f}
        </div>
      ))}
    </div>
  </section>
);

export default ProofStrip;
